import React from "react";
import "./Strategies.css";
import { useLocalContext } from "../../context/LocalContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGaugeHigh,
  faShieldHalved,
  faServer,
  faHeadset,
  faArrowsRotate,
  faEarthAmericas,
} from "@fortawesome/free-solid-svg-icons";

const strategyItems = [
  {
    icon: faGaugeHigh,
    title: "Performance-first infrastructure",
    description:
      "SSD-backed storage, modern HTTP stacks, and sensible caching so your pages respond quickly for visitors everywhere.",
  },
  {
    icon: faShieldHalved,
    title: "Security baked in",
    description:
      "Free SSL options, isolated accounts on shared platforms, and guidance on hardening WordPress, PHP apps, and DNS.",
  },
  {
    icon: faServer,
    title: "Clear upgrade paths",
    description:
      "Start on shared hosting and move to WordPress-optimized or VPS plans when traffic and complexity grow — without rebuilding from scratch.",
  },
  {
    icon: faHeadset,
    title: "Humans when it matters",
    description:
      "Real support for migrations, DNS cutovers, email deliverability, and those “site is down” moments — not just ticket bots.",
  },
  {
    icon: faArrowsRotate,
    title: "Backups you can trust",
    description:
      "Automated backup options and restore workflows so you can recover from bad updates or accidents with less panic.",
  },
  {
    icon: faEarthAmericas,
    title: "DNS & domains simplified",
    description:
      "We help you point domains, add subdomains, and align MX/TXT records so hosting, SSL, and email work together.",
  },
];

const Strategies = () => {
  const { webinfo = {} } = useLocalContext();
  const brand = webinfo?.name || "virtuedigihost.com";

  return (
    <section className="sg-about" aria-label="Why choose our hosting">
      <div className="sg-about-wrap">
        <header className="sg-about-head">
          <span className="sg-about-kicker">Why Virtue Digi</span>
          <h2>Infrastructure you can explain to your team</h2>
          <p>
            {brand} is built around predictable uptime, readable specs, and
            support that knows DNS, SSL, and migrations—not just ticket queues.
            From a simple blog to a busy store, we help you land on the right
            tier without the jargon.
          </p>
        </header>

        <div className="sg-about-grid">
          {strategyItems.map((item) => (
            <article className="sg-about-card" key={item.title}>
              <div className="sg-about-icon">
                <FontAwesomeIcon icon={item.icon} />
              </div>

              <div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Strategies;
